/**
 * 接口域名的管理
 */
const base = {    
    // sq: 'https://beingmate-scrm.beingmate.com/api',    
    // sq:'http://10.20.103.2:8080/',
    // sq: 'http://10.100.111.208:8082/',
    // external:'http://beingmate.mountor.com/api',
    // bj:'https://beijia.beingmate.com/api',
    v1 :'https://beingmate-scrm-v1.beingmate.com/api',
    v2 :'https://beingmate-scrm-v2.beingmate.com/api'
    

}

export default base;